import { isFapiaoValid } from './fapiao';
import { formatUrl } from './payment-utils';
import { isSecondaryBlockOpened } from './payment';

export function OneyFacilipay() {

  this.init = function init(params) {
    this.parent = params.parent;
    this.container = params.container;
    this.onExpressConfirmation = params.onExpressConfirmation;
    this.header = this.container.querySelector('.dkt-block-header');
    this.content = this.container.querySelector('.dkt-block-content');

    this.props = {
      id: this.container.getAttribute('data-payment-type-id'),
      multiEnabled: this.container.getAttribute('data-multi-enabled'),
      orderId: params.orderId,
      isExpress: params.isExpress || false,
      isCheckout: params.isCheckout || false
    };

    this.state = {
      selected: params.selected || false
    };

    if (this.state.selected === true) {
      this.select();
    }

    this.events();

  };
}

OneyFacilipay.prototype.events = function events() {
  if (this.props.isExpress === false) {
    this.header.addEventListener('click', this.select.bind(this));
  }
  document.addEventListener('clickedOnPay', this.check.bind(this));
  document.addEventListener('PrimaryPaymentBlockSelected', this.unselect.bind(this));
  document.addEventListener('SecondaryPaymentChanged', this.checkAmount.bind(this));
};

OneyFacilipay.prototype.checkAmount = function checkAmount() {
  // TO DO : Make this verification in back, it's normaly not a front rule
  const amount = cube.$('[data-primary-amount]').dataset.primaryAmount;
  if(amount < 90 || amount > 2500 ) {
    cube.$('[data-payment-name=ONEY_-_FACILYPAY]').style.display = 'none';
  } else {
    cube.$('[data-payment-name=ONEY_-_FACILYPAY]').style.display = 'block';
  }
};

OneyFacilipay.prototype.select = function select(event) {
  if ((this.state.selected === false && event) || !event) {
    document.dispatchEvent(new CustomEvent('PrimaryPaymentBlockSelected', {
      bubbles: false,
      cancelable: false,
      detail: {
        'multiEnabled': this.props.multiEnabled
      }
    }));

    $(this.content).slideDown('fast', this.displaySelected.bind(this));
    this.state.selected = true;
    if (this.props.isExpress === false) {
      this.parent.enableButton();
    }
  }
};

OneyFacilipay.prototype.displaySelected = function displaySelected() {
  this.container.classList.add('dkt-block--selected');
  this.container.classList.add('dkt-block--open');
};

OneyFacilipay.prototype.displayUnselected = function displayUnselected() {
  this.container.classList.remove('dkt-block--selected');
  this.container.classList.remove('dkt-block--open');
};

OneyFacilipay.prototype.unselect = function unselect() {
  $(this.content).slideUp('normal', this.displayUnselected.bind(this));
  this.state.selected = false;
};

OneyFacilipay.prototype.check = function check() {
  if (this.parent.checkTermsOfUse && this.parent.checkTermsOfUse() === false) {
    return;
  }

  if (this.props.isCheckout === true) {
    if (this.parent.checkBillingAddress && this.parent.checkBillingAddress() === false) {
      return;
    }
    if (this.parent.isFullSecondaryPayment && this.parent.isFullSecondaryPayment() === true) {
      return;
    }
    if (isFapiaoValid() === false) {
      return;
    }
  }

  if (this.state.selected === true) {
    this.submitPayment();
  }
};

OneyFacilipay.prototype.submitPayment = function submitPayment() {
  if (document.getElementById('orderTrackingUrl') !== null) {
    this.props.orderTracking = document.getElementById('orderTrackingUrl').value;
  }

  if (document.getElementById('redirectionUrl') !== null) {
    this.props.redirectionUrl = document.getElementById('redirectionUrl').value;
  }

  const changePaymentMethodTag = cube.$id('change-payment-method');
  const changePaymentMethod = changePaymentMethodTag ? changePaymentMethodTag.value === 'true' : false;

  let params = {
    'changePaymentMethod': changePaymentMethod,
    orderId: this.props.orderId,
    paymentTypeId: this.props.id,
    redirectionUrl: this.props.redirectionUrl,
    paymentUrl: window.location.href,
    useSecondaryMop: isSecondaryBlockOpened(),
    additionnalParameters: JSON.stringify({
      bank: this.selectedBank
    })
  };

  if (this.parent.addFapiaoParams) {
    params = this.parent.addFapiaoParams(params);
  }

  if (this.parent.getAnalyticsInfos) {
    params.orderAttributes = JSON.stringify(this.parent.getAnalyticsInfos());
  }

  this.parent.displayLoader();
  cube.ajax.post(formatUrl('applyPayment', params.orderId), params)
    .onSuccess(this.submitPaymentSuccess.bind(this))
    .call();
};

OneyFacilipay.prototype.submitPaymentSuccess = function submitPaymentSuccess(response) {
  if (response && response.result && response.result.data) {
    const data = response.result.data;

    if (window.cube.config.anly_useLegacy === 'Y') {
      CUBE.Analytics.queue.send('proceedToConfirmation');
    }
    if (data.paymentModifiable === 'false') {
      window.location.reload();
    }

    if (data.redirectConfirmation === 'true') {
      window.location.href = data.redirectionUrl;
    }

    if (data.paymentAction === 'REDIRECTION_DIRECT') {
      window.location.href = data.urlValidation;
    }

    if (data.reloadExpressCartridge && data.reloadExpressCartridge === 'true') {
      this.onExpressConfirmation(data.redirectConfirmation);
    }

    if (data.redirectPspForm !== null) {
      const paymentRedirectForm = document.getElementById('payment-redirect-form');
      paymentRedirectForm.innerHTML = data.redirectPspForm;
      paymentRedirectForm.querySelector('form').submit();
    }
  } else {
    this.parent.hideLoader();
    if (this.parent.displayError) {
      this.parent.displayError(response.responseTO.errors[0].message);
    }
  }
};



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-oneyfacilipay.js